import React, { memo } from 'react';
import Heading from '@atlaskit/heading';
import { Inline, Stack, xcss } from '@atlaskit/primitives';
import { BackNavButton } from './NavigationButton';
var itemContainerStyles = xcss({
  paddingTop: 'space.100',
  paddingBottom: 'space.025',
  paddingLeft: 'space.250',
  paddingRight: 'space.250'
});
export var SubPanelWithBackButton = /*#__PURE__*/memo(function (_ref) {
  var label = _ref.label,
    buttonLabel = _ref.buttonLabel,
    onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Stack, {
    space: "space.0"
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    alignInline: "start",
    space: 'space.050',
    xcss: itemContainerStyles
  }, /*#__PURE__*/React.createElement(BackNavButton, {
    onClick: onClick,
    label: buttonLabel
  }), /*#__PURE__*/React.createElement(Heading, {
    size: 'xsmall',
    as: "span"
  }, label)), children);
});